import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Model } from '../../../../models/model';
import { ModelloCompagnia } from '../../../../models/modello-compagnia';
import { ModelloCompagniaComponent } from '../../../../anagrafiche/modello-compagnia/modello-compagnia.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => CgaPickerComponent) },
  ],
  selector: 'cga-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class CgaPickerComponent extends ExternalSelectorComponent {

  @Input() displayField: string = 'humanIdentifier';
@Input() multipleSelection = false;
  @Input()
  get externalEntityObserver(): Observable<any> {
    let picked = this.dialog.open(ModelloCompagniaComponent, { data: { selectionMode: !this.multipleSelection, multipleSelection: this.multipleSelection, showReset: true } }).afterClosed();
    picked.subscribe(val => {
      let modelloCompagnia = new ModelloCompagnia().deserialize(val);
      return modelloCompagnia;
    });
    return picked;
  };

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  query: FormGroup = this.fb.group({
    states: new FormArray([])
  });

  registerOnChange(onChange: (value: Model | null) => void): void {
    if (this.multipleSelection) {
    this.query.valueChanges.pipe(
      takeUntil(this.destroy),
    ).subscribe((value) => { if (value.states) onChange(value.states)});
    } else super.registerOnChange(onChange)
  }

    public writeValue(value?: any): any {
    if (value === null) {
        this.parts.reset();
        const statesArray = this.query.get('states') as FormArray
        statesArray.clear();
        this.stateChanges.next();
    }
    else if (this.multipleSelection) {
        const displayText = value.map(item => item[this.displayField]).join(', ');
        this.parts.patchValue({ humanIdentifier: displayText });
        const states = new FormArray(value.map(item => (new FormControl(item.id))))
        this.query.setControl('states', states)
        this.stateChanges.next();
    } else {
        if (value) {
        this.parts.patchValue({ 
            humanIdentifier: value[this.displayField],
            id: value.id 
        });
        }
        this.stateChanges.next();
    }
    }
}
